import { useNavigate } from 'react-router-dom';

export const useAppNavigation = () => {
  const navigate = useNavigate();

  return {
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    navigateTo: (
      path: string,
      options?: { replace?: boolean; state?: unknown },
    ) => navigate(path, options),
  };
};
